import { changeBoneFloors } from "./index204.js";
function redoAction({ obj, aggProps, action }) {
	return changeBoneFloors({
		obj,
		aggProps,
		...action.redo
	}).output;
}
export { redoAction };

//# sourceMappingURL=index222.js.map